export interface CertificationInfo {
  certificationId: number;
  name: string;
  version: number;
}

export interface PhaseInfo {
  phaseId: number;
  name: string;
  steps: StepInfo[];
}

export interface StepInfo {
  stepId: number;
  name: string;
  stepType: number;
}

export interface PdfTemplateInfo {
  pdfTemplateId: number;
  name: string;
  description: string;
  externalTemplateId: string;
  externalTitle: string;
  organizationId?: number;
  masterTemplateId?: number;
  stateId?: number;
  source: string;
  version: number;
  isLatestVersion: boolean;
  parentVersionId: number;
  fields?: PdfTemplateField[];
}

export interface OrgNameAndId {
  name: string;
  organizationId: null;
}

export interface OrgTemplateSettings {
  pdfTemplatePhaseStepGenerationId?: string;
  pdfTemplateId: number;
  organizationId: number;
  certificationId?: number;
  phaseId?: number;
  phaseName?: string;
  stepId?: number;
  stepName?: string;
  isLatestVersion: boolean;
  parentCertificationId?: number;
  useParentVersion: boolean;
  organizationTemplateName: string;
  saveToDigitalWallet: boolean;
  showInDigitalWallet: boolean;
  published: boolean;
  sendEmailToProfessional: boolean;
  professionalEmailTemplateName?: string;
  sendEmailToAdmin: boolean;
  adminEmailTemplateName?: string;
  typeId: number;
  effectiveStartDate: Date;
  effectiveEndDate?: Date;
  templateInfo?: PdfTemplateInfo;
  fieldMappingInfo?: PdfTemplateFieldOrganizationCustomFieldData[];
  signatureMappingInfo?: PdfTemplateFieldSignatureData[];
  radioMappingInfo?: PdfTemplateFieldRadioOptionCustomFieldValueData[];
  certificationInfo?: CertificationInfo;
}

export interface AssignmentSearchParameters {
  pdfTemplateId: number;
  organizationId: number;
  certificationId?: number;
  phaseId?: number;
  stepId?: number;
}

export interface PdfTemplateFieldSignatureData {
  pdfTemplateFieldSignatureId: number;
  pdfTemplateFieldId: number;
  pdfTemplatePhaseStepGenerationId: number;
  stepId: number;
  signatureTypeId: number;
}

export interface PdfTemplateFieldOrganizationCustomFieldData {
  pdfTemplateFieldOrganizationCustomFieldId: number;
  pdfTemplatePhaseStepGenerationId: number;
  pdfTemplateFieldId: number;
  customFieldId: number;
  multiselectOptionValue?: string;
}

export interface PdfTemplateFieldRadioOptionCustomFieldValueData {
  pdfTemplateFieldRadioOptionCustomFieldValueId: number;
  pdfTemplatePhaseStepGenerationId: number;
  value: string;
  pdfTemplateFieldRadioOptionId: number;
}

export interface PdfTemplateField {
  pdfTemplateFieldId: string;
  pdfTemplateId: number;
  name: string;
  jsonName: string;
  defaultValue?: string;
  fieldType: PDF_FIELD_TYPE;
  radioOptions: RadioOptionInfo[];
  signatureInfo?: SignatureInfo;
  customFieldId?: number;
  multiselectOptionValue?: string;
}

export interface RadioOptionInfo {
  pdfTemplateFieldRadioOptionId: string;
  pdfTemplateFieldId: number;
  displayName: string;
  optionValue: string;
  customFieldValue?: string;
}

export interface SignatureInfo {
  stepId: number;
  signatureType: SIGNATURE_TYPE;
}

export interface PdfTemplateFieldMapping {
  pdfTemplateFieldId: string;
  pdfTemplateId: number;
  customFieldId: number;
  multiselectOptionValue?: string;
  radioOptions?: PdfTemplateFieldRadioMapping[];
  signatureInfo?: PdfTemplateFieldSignatureMapping;
}

export interface PdfTemplateFieldRadioMapping {
  pdfTemplateFieldRadioOptionId: string;
  value: string;
}

export interface PdfTemplateFieldSignatureMapping {
  pdfTemplateFieldId: string;
  pdfTemplateId: number;
  stepId: number;
  signatureType: SIGNATURE_TYPE;
}

export enum PDF_FIELD_TYPE {
  GENERIC = 1,
  BOOLEAN,
  RADIO,
  PHONE,
  DYNAMIC_FORM_SIGNATURE,
  SUBMISSION_SIGNATURE,
  DATE,
}

export enum SIGNATURE_TYPE {
  PROFESSIONAL = 1,
  ADMINISTRATION,
  SECONDARY_ADMINISTRATOR,
}

export interface OrgTemplateMappingRequest {
  settings: OrgTemplateSettings;
  fields: PdfTemplateFieldMapping[];
  signatureInfo: PdfTemplateFieldSignatureMapping[];
}

export interface ManuallyGeneratePdfRequest {
  pdfTemplateId: number;
  profileId: number;
  certificationId: number;
  organizationId: number;
  typeId: number;
  source: string;
  saveToDigitalWallet: boolean;
  showInDigitalWallet: boolean;
  sendEmailToProfessional: boolean;
  professionalEmailTemplate: string;
  sendEmailToAdmin: boolean;
  adminEmailTemplate: string;
  organizationTemplateName: string;
}

export interface CreatePdfTemplateRequest {
  pdfTemplateId?: string;
  name: string;
  description?: string;
  externalTemplateId: string;
  externalTitle: string;
  organizationId?: number;
  masterTemplateId?: number;
  stateId?: number;
  source: string;
  fields: CreatePdfTemplateField[];
}

export interface CreatePdfTemplateField {
  pdfTemplateFieldId?: string;
  name: string;
  jsonName: string;
  defaultValue?: string;
  fieldType: number;
  radioOptions: CreatePdfTemplateFieldRadioOption[];
}

export interface CreatePdfTemplateFieldRadioOption {
  pdfTemplateFieldRadioOptionId?: string;
  displayName: string;
  optionValue: string;
}

export interface StateData {
  stateId: number;
  name: string;
  stateCode: string;
  countryId: number;
}
